import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button, Card } from "@nutrayan/ui";

/** Shown when an admin navigates to a page their role doesn't permit. */
export default function UnauthorizedPage() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex max-w-md flex-col items-center py-16 text-center">
      <Card className="w-full">
        <div className="bg-terracotta/10 text-terracotta mx-auto flex h-14 w-14 items-center justify-center rounded-full">
          <ShieldAlert size={26} aria-hidden />
        </div>
        <h1 className="font-display text-display-md text-charcoal mt-4">Access restricted</h1>
        <p className="text-body-sm text-ink mt-2">
          You don&apos;t have permission to view this page. If you believe this is a mistake,
          contact your administrator.
        </p>
        <Button size="lg" fullWidth className="mt-6" onClick={() => navigate("/dashboard")}>
          Back to dashboard
        </Button>
      </Card>
    </div>
  );
}
